import React from 'react';
import { Tab } from 'src/components/sticky-tab-nav/types';
import { ProductPageQuery } from 'src/types';
import {
  MainTabId,
  PropertiesTabId,
  ReviewsTabId,
  StatisticsTabId,
} from '../product-tabs/constants';

import {
  ProductNavigationMainLink,
  ProductNavigationPropertiesLink,
  ProductNavigationReviewsLink,
  ProductNavigationHistoryLink,
} from './links/product-section-navigation-links';

export const getLinks = (product: ProductPageQuery['product']): Tab[] => {
  return [
    {
      id: MainTabId,
      title: <ProductNavigationMainLink product={product} />,
    },
    {
      id: PropertiesTabId,
      title: <ProductNavigationPropertiesLink product={product} />,
    },
    {
      id: ReviewsTabId,
      title: <ProductNavigationReviewsLink product={product} />,
    },
    {
      id: StatisticsTabId,
      title: <ProductNavigationHistoryLink product={product} />,
    },
  ];
};
